/**
 * PIP: mapování telemetrie → MQTT topic suffix. Zdroj pravdy pro server publish i klientskou živou hodnotu.
 * Pořadí klíčů = pořadí původních publish volání (pip/index.ts). Škálování/formát reprodukuje původní výstup.
 */

import type { MetricValue, PipTelemetryShape, TopicMap } from "@globals/telemetry/types";

const fixed = (digits: number) => (v: MetricValue) => (v as number).toFixed(digits);

export const PIP_TOPIC_MAP: TopicMap<PipTelemetryShape> = {
  "grid-v": { get: (t) => t.gridVoltageV, format: fixed(1) },
  "grid-hz": { get: (t) => t.gridFrequencyHz, format: fixed(1) },
  "ac-out-v": { get: (t) => t.acOutputVoltageV, format: fixed(1) },
  "ac-out-hz": { get: (t) => t.acOutputFrequencyHz, format: fixed(1) },
  "ac-out-va": { get: (t) => t.acOutputApparentVA },
  "ac-out-w": { get: (t) => t.acOutputActiveW },
  "ac-out-percent": { get: (t) => t.outputLoadPercent },
  "bus-v": { get: (t) => t.busVoltageV },
  "heatsink-temp": { get: (t) => t.heatsinkTempC },
  "battery-v": { get: (t) => t.batteryVoltageV, format: fixed(2) },
  "battery-scc-v": { get: (t) => t.batteryVoltageFromSccV, format: fixed(2) },
  "battery-charge-a": { get: (t) => t.batteryChargingA },
  "battery-discharge-a": { get: (t) => t.batteryDischargeA },
  "battery-soc": { get: (t) => t.batterySocPercent },
  "pv-v": { get: (t) => t.pvInputVoltageV, format: fixed(1) },
  "pv-a": { get: (t) => t.pvInputCurrentA },
  "pv-w": { get: (t) => t.pvChargingPowerW },
  "pv2-v": { get: (t) => t.pv2InputVoltageV, cond: (t) => t.pv2InputVoltageV !== null, format: fixed(1) },
  "pv2-a": { get: (t) => t.pv2InputCurrentA, cond: (t) => t.pv2InputCurrentA !== null },
  "pv2-w": { get: (t) => t.pv2ChargingPowerW, cond: (t) => t.pv2ChargingPowerW !== null },
  mode: { get: (t) => t.mode },
  "alarms-active-count": { get: (t) => t.activeWarnings.length },
  "alarms-bitmap": { get: (t) => t.warningsBitfield },
};
